var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      (typeof _vm.vendorGlobalInsuranceID === 'string' ||
        typeof _vm.vendorGlobalInsuranceID === 'number') &&
        _vm.documentID > 0
    )?_c('span',[_c('button',{staticClass:"button is-info is-light is-small is-outline is-rounded",on:{"click":function($event){$event.preventDefault();return _vm.downloadPdf(_vm.vendorGlobalInsuranceID)}}},[_vm._v(" Pdf ")])]):_c('span',[_vm._v("   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }